<template>
  <v-container fluid fill-height class="portfolio-container">
    <v-row class="text-left">

      <v-col cols="12">
        <h1 class="display-2 font-weight-bold mb-3">
          FUEL INDUSTRIES
        </h1>

        <h3 class="subheading font-weight-regular">
          Fuel Industries was a leading developer in flash-based adver-games. It might sound a little wierd at first, but there are probably more adver-games out there than you realize. Video Game Advertisements is another medium of which companies can advertise their product. While a video ad can last 5-30 seconds, a game done well could potentially pull you in for hours.<p/>
          At my time there, I worked on a lot of different projects. They ranged from puzzle games, action games, and even platformers. While the business was very challenging with it's short timelines and numerous projects, it was always a pleasure to work on so many different types of games while I was working there.
        </h3>
      </v-col>

      <v-timeline dense>
        <v-timeline-item right>
          <v-card class="elevation-2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="headline">Disrespectoids 2</v-list-item-title>
                <v-list-item-subtitle>2010</v-list-item-subtitle>
                In the late 2000s, CapriSun's slogan was first about "Respecting the Pouch", but what if you disrespected it? With 10 playable characters, 4 levels, each with 4 stages, my last projects at Fuel was a really big one.<br/><br/>
                Each level is divided into 4 stages: A platform level, a tower-defense style mini-game, another platform level, then finishing with a 3D boss battle. The 3D boss battle was pretty unique in the sense that 3D over the web was a pretty new concept, and definitely not a very performant option.<br/><br/>
                When the project first started out, the first 3 stages were fairly straightforward to engineer. Doing a 3D boss fight in Flash though was not. When the project first started, I was basically given around a week to figure out if it could even be done. There were 3 options:
                <ul>
                  <li>Completely fake it. This is the last resort if nothing works. Basically fake 3D with perspective tricks</li>
                  <li>Use a 3D library. While is allowed me to create an actual room in 3D, at the time web browsers just weren't powerful enough. Even on a high-end machine, you could barely get more than 10 fps</li>
                  <li>Use Flash's new Z-rotation on images. By rotating images "downward", we were able to make an amazing 3D-like environment without hurting the framerate</li>
                </ul><br/>
                This was an incredibly fun project to work on, and being able to essentially write a platformer and 3D boss engine from scratch, while allowing 10 playable characters each with unique abilities was a pretty challenging experience. It was also mostly my responsibility to do the level design across all 8 platform levels. The game even had analytics tracking to track user progress (turns out level 3-3 was too hard at first).
              </v-list-item-content>
              <v-img contain max-width="200" max-height="150" src="@/assets/fuel/2010_disrespectoids.jpg"></v-img>
            </v-list-item>
            <v-card max-width="515" style="margin: auto;">
              <v-carousel cycle interval="10000" show-arrows-on-hover hide-delimiters height="200">
                <v-carousel-item><v-img src="@/assets/fuel/2010_disrespectoids_slide1.jpg"></v-img></v-carousel-item>
                <v-carousel-item><v-img src="@/assets/fuel/2010_disrespectoids_slide2.jpg"></v-img></v-carousel-item>
                <v-carousel-item><v-img src="@/assets/fuel/2010_disrespectoids_slide3.jpg"></v-img></v-carousel-item>
                <v-carousel-item><v-img src="@/assets/fuel/2010_disrespectoids_slide4.jpg"></v-img></v-carousel-item>
                <v-carousel-item><v-img src="@/assets/fuel/2010_disrespectoids_slide5.jpg"></v-img></v-carousel-item>
                <v-carousel-item><v-img src="@/assets/fuel/2010_disrespectoids_slide6.jpg"></v-img></v-carousel-item>
              </v-carousel>
            </v-card>
            <br/>
          </v-card>
        </v-timeline-item>

        <v-timeline-item right>
          <v-card class="elevation-2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="headline">Shrek Happy Meal Board Game</v-list-item-title>
                <v-list-item-subtitle>2010</v-list-item-subtitle>
                Along with the release of Shrek 4, Fuel Industries partnered with McDonalds to promote the Shrek 4 Happy Meal.<br/><br/>
                The game was fairly large. The player moved across a board game, and landing on certain tiles would start a mini game (Mario Party Style). My contributions to the project as a whole was pretty small, but I did get to make an incredibly fun game called <b>Ginger Snaps!</b>
              </v-list-item-content>
              <v-img contain max-width="200" max-height="150" src="@/assets/fuel/2010_shrek.jpg" @click="dialog=true"></v-img>
            </v-list-item>
          </v-card>
        </v-timeline-item>

        <v-timeline-item right>
          <v-card class="elevation-2">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="headline">Game</v-list-item-title>
                <v-list-item-subtitle>2009</v-list-item-subtitle>
                Blah blah blah
              </v-list-item-content>
              <v-img contain max-width="200" max-height="150" src="@/assets/fuel/2010_shrek.jpg" @click="dialog=true"></v-img>
            </v-list-item>
          </v-card>
        </v-timeline-item>

      </v-timeline>
    </v-row>
    <v-dialog v-if="dialog" v-model="dialog" max-width="800">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Ginger Snaps!
        </v-card-title>

        <v-card-text>
          <vue-core-video-player src="http://classicalgamer.com/video/2010_shrek_360.mp4"></vue-core-video-player>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
    }),
  }
</script>

<style type="text/css" scoped>
.portfolio-container {
  padding-top: 50px;
  padding-left: 50px;
  padding-right: 50px;
  background: #fff;
}
</style>
